<div class="wrapper">
  @if (iconName) {
    <app-icon class="icon" [name]="iconName"></app-icon>
  }
  <h2 class="title">{{ title }}</h2>
  <p class="description">{{ description }}</p>
  @if (actionLabel) {
    <rc-button data-qa="vs-no-results-button-action" (click)="emitAction()" id="no-results-action">
      {{ actionLabel }}
    </rc-button>
  }
</div>
